import { render, staticRenderFns } from "./activity_add.vue?vue&type=template&id=577f8e15&scoped=true&"
import script from "./activity_add.vue?vue&type=script&lang=js&"
export * from "./activity_add.vue?vue&type=script&lang=js&"
import style0 from "./activity_add.vue?vue&type=style&index=0&id=577f8e15&lang=less&scoped=true&"
import style1 from "./activity_add.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f8e15",
  null
  
)

export default component.exports